import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { makeRequestAuth } from "../../../_config/api";

const BarChartServiceBooking = () => {
    const [fetchedData, setFetchedData] = useState({ categories: [], series: [] });
    const [year, setYear] = useState("2026");
    const [month, setMonth] = useState("");
        const [location, setLocation] = useState("All Locations");
    const [locations, setLocations] = useState(["All Locations"]);
    const [status, setStatus] = useState("All");

    const years = ["2025", "2026", "2027", "2028", "2029", "2030"];

    // Dynamic Cities Fetch Effect
     // Dynamic Cities Fetch Effect
    useEffect(() => {
        const fetchCities = async () => {
            try {
                const res = await makeRequestAuth("post", "/admin/getCityList", { keyword: "" });
                if (res?.code === 0 && Array.isArray(res.data)) {
                    const cityNames = res.data.map(c => c.cityName).filter(Boolean);
                    setLocations(["All Locations", ...cityNames]);
                }
            } catch (err) {
                console.error("City fetch failed", err);
            }
        };
        fetchCities();
    }, []);


    const statuses = ["All", "approved", "pending", "sold", "rejected"];
    const months = [
        { name: "All Months", value: "" },
        { name: "Jan", value: "1" },
        { name: "Feb", value: "2" },
        { name: "Mar", value: "3" },
        { name: "Apr", value: "4" },
        { name: "May", value: "5" },
        { name: "Jun", value: "6" },
        { name: "Jul", value: "7" },
        { name: "Aug", value: "8" },
        { name: "Sep", value: "9" },
        { name: "Oct", value: "10" },
        { name: "Nov", value: "11" },
        { name: "Dec", value: "12" },
    ];

    useEffect(() => {
        const fetchChartData = async () => {
            try {
                const resData = { 
                    year: year, 
                    month: month, 
                    location: location === "All Locations" ? "" : location,
                    status: status === "All" ? "" : status
                };
                const response = await makeRequestAuth("post", "/admin/serviceBookingChart", resData);

                if (response?.code === 0 && !response.error && response?.data) {
                    setFetchedData(response.data);
                } else {
                    console.error("Server Error:", response?.data?.message || "Unknown error");
                }
            } catch (error) {
                console.error("Request Failed:", error);
            }
        };

        fetchChartData();
    }, [year, month, location, status]);

    const defaultCategories = ["AC Service", "Carpenter Service", "Decoration", "Electrician", "Painters", "Plumbers", "Security Guard"];

     const chartCategories = Array.isArray(fetchedData?.categories) && fetchedData.categories.length > 0
        ? fetchedData.categories.map(cat => {
            let clean = String(cat).replace(/\s*\(.*?\)\s*/g, '').trim();
            let words = clean.split(' ');
            // 2 ya 2 se zyada words walo ko 2 lines me split karein
            if (words.length >= 2) {
                return [words[0], words.slice(1).join(' ')];
            }
            return clean;
          }) 
        : defaultCategories;



    // Series array with matching length safety check
    const chartSeries = Array.isArray(fetchedData?.series) && fetchedData.series.length > 0
        ? fetchedData.series.map(s => ({
            name: s.name,
            data: chartCategories.map((_, idx) => Number(s?.data?.[idx]) || 0)
          }))
        : [
            { name: "Approved", data: chartCategories.map(() => 0) },
            { name: "Pending", data: chartCategories.map(() => 0) },
            { name: "Sold", data: chartCategories.map(() => 0) },
            { name: "Rejected", data: chartCategories.map(() => 0) }
          ];

    // Safe Max Value calculation for Y-Axis
    const categoryTotals = chartCategories.map((_, index) => {
        return chartSeries.reduce((sum, s) => sum + (Number(s?.data?.[index]) || 0), 0);
    });
    const calculatedMax = Math.max(...categoryTotals, 0);
    const maxVal = calculatedMax > 0 ? calculatedMax : 27;

    const chartOptions = {
        chart: {
            type: "bar",
            stacked: true,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                columnWidth: "35%",
                borderRadius: 5,
            },
        },
        xaxis: {
            categories: chartCategories,
            labels: {
                rotate: 0,
                rotateAlways: false,
                hideOverlappingLabels: false,
                style: {
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#6b7280",
                },
            },
        },
         
        yaxis: {
            tickAmount: 4,
            min: 0,
            max: maxVal,
            labels: {
                formatter: (val) => {
                    if (val === undefined || val === null || isNaN(val)) return "0";
                    return Number.isInteger(val) ? `${val}` : `${val.toFixed(2)}`;
                },
                style: {
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#6b7280",
                },
            },
        },
        grid: {
            yaxis: { lines: { show: false } },
        },
        colors: ["#10B981", "#F59E0B", "#3B82F6", "#EF4444"], // Approved (Green), Pending (Orange), Sold (Blue), Rejected (Red)
        dataLabels: {
            enabled: false,
        },
        legend: {
            position: "top",
            horizontalAlign: "right",
            fontSize: "12px",
            fontWeight: 500,
            markers: {
                radius: 12
            }
        },
                tooltip: {
            theme: "light",
            shared: false,
            intersect: true,
            y: {
                formatter: (val) => `${val || 0} Bookings`
            }
        },

    };

    return (
        <div className="bg-white p-4 rounded-2xl shadow-md w-full mx-auto">
            <div className="flex flex-wrap justify-between items-center mb-4 gap-2">
                <h2 className="text-sm font-semibold text-gray-700">
                    Service Bookings By Category
                </h2>

                <div className="flex gap-2 flex-wrap">
                    {/* 1. Year Filter */}
                    <select
                        className="px-3 py-1 rounded border border-gray-300 text-sm text-gray-700"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                    >
                        {years.map((y) => (
                            <option key={y} value={y}>{y}</option>
                        ))}
                    </select>

                    {/* 2. Month Filter */}
                    <select
                        className="px-3 py-1 rounded border border-gray-300 text-sm text-gray-700"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                    >
                        {months.map((m) => (
                            <option key={m.value} value={m.value}>
                                {m.name}
                            </option>
                        ))}
                    </select>

                    {/* 3. Location Filter */}
                    <select
                        className="px-3 py-1 rounded border border-gray-300 text-sm text-gray-700"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                    >
                        {locations.map((loc) => (
                            <option key={loc} value={loc}>
                                {loc}
                            </option>
                        ))}
                    </select>

                    {/* 4. Status Filter */}
                    <select
                        className="px-3 py-1 rounded border border-gray-300 text-sm text-gray-700"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        {statuses.map((s) => (
                            <option key={s} value={s}>
                                {s.charAt(0).toUpperCase() + s.slice(1)}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

                    {/* Horizontal Slider / Scrollbar Container */}
                      {/* Horizontal Slider / Scrollbar Container */}
            <div className="w-full overflow-x-auto pb-4 custom-scrollbar">
<div className="min-w-[2000px]">
                    <Chart
                        options={chartOptions}
                        series={chartSeries}
                        type="bar"
                        height={250}
                        width="100%"
                    />
                </div>
            </div>


        </div>
    );
};

export default BarChartServiceBooking;
